// Pass-tier checks. Bizzabo puts the attendee's pass name(s) on the session
// user as `ticketType` — an array of strings like ['VIP - Complimentary'],
// ['General Admission'], ['HubSpotter'] or ['Test'].
//
// Pure + Vue-free so it's safe to import from Nitro server routes (a `ref`/
// `computed` in shared/ crashes the Worker on cold start).

const asList = (ticketType) => {
    if (Array.isArray(ticketType)) return ticketType;
    return ticketType ? [ticketType] : [];
};

// Matches the substring test used by the seat-reservation routes
// (server/api/v2/reservations/*.post.js) so pass tiers are read consistently.
export function isVipTicket(ticketType) {
    return asList(ticketType).some((type) => typeof type === 'string' && type.includes('VIP'));
}

// Partner Day approval is its own Bizzabo registration answer — the "Partner
// Day" question under Additional Registration Details, stored on the contact as
// `partner_day` and copied onto the session user as `partnerDay` at login. It
// holds one of 'Approved', 'Applied' or 'Declined', and is absent for the
// majority who never applied.
//
// It is NOT the pass tier, and the two do not correlate: in the live event data
// 373 General Admission holders are Approved (more than the 285 approved VIPs),
// while some VIP holders are only Applied or Declined. The previous
// isVipTicket() check therefore locked out hundreds of approved partners AND
// auto-added Partner Day for un-approved VIPs (Asana UNB-600).
//
// Only 'Approved' passes. Absent (a pre-UNB-600 session cookie, or a contact who
// never applied) fails closed.
export const PARTNER_DAY_APPROVED = 'Approved';

export function canAccessPartnerDay(user) {
    const status = user?.partnerDay;
    if (typeof status !== 'string') return false;
    return status.trim().toLowerCase() === PARTNER_DAY_APPROVED.toLowerCase();
}
